import _ from 'lodash'
import { d } from 'core/service/lib/decimal'
import { createSelector } from 'reselect'
import { formatNumber } from 'core/service/lib/number-format'

export const getLastGuaranteeDividend = (state) => {
  const lastIndex = _.get(state, 'benefitIllustration.policyValue.yearEndPolicyValues', []).length
  return _.get(state, `benefitIllustration.policyValue.yearEndPolicyValues.${lastIndex - 1}.guaranteeDividend`, 0)
}

export const getLastLowInterestDeposit = (state) => {
  return _.get(state, 'benefitIllustration.policyValue.subTotalLowInterest', 0)
}

export const getLastMidInterestDeposit = (state) => {
  return _.get(state, 'benefitIllustration.policyValue.subTotalMidInterest', 0)
}

export const getLastHighInterestDeposit = (state) => {
  return _.get(state, 'benefitIllustration.policyValue.subTotalHighInterest', 0)
}

export const getTotalGuaranteeDividend = (state) =>
  _.get(state, 'benefitIllustration.policyValue.subtotalGuaranteeDividend', 0)

const _dashedOutOrWithPrecision = (value, precision = 0, isRound = true) =>
  value === 0 ? '-' : formatNumber(value, precision, isRound)

export const getDisplayBenefitSummaryTable = createSelector(
  getTotalGuaranteeDividend,
  getLastGuaranteeDividend,
  getLastLowInterestDeposit,
  getLastMidInterestDeposit,
  getLastHighInterestDeposit,
  (
    totalGuaranteeDividend,
    lastGuaranteeDividend,
    lastLowInterestDeposit,
    lastMidInterestDeposit,
    lastHighInterestDeposit
  ) => {
    return {
      totalGuaranteeDividend: _dashedOutOrWithPrecision(totalGuaranteeDividend),
      lastGuaranteeDividend: _dashedOutOrWithPrecision(lastGuaranteeDividend),
      totalGuaranteeDividendBeforeLastYear: _dashedOutOrWithPrecision(
        d(totalGuaranteeDividend)
          .minus(lastGuaranteeDividend)
          .toNumber()
      ),
      nonGuaranteeDividendBeforeDueDate: {
        interestDeposit: _dashedOutOrWithPrecision(0),
        lowInterestDeposit: _dashedOutOrWithPrecision(lastLowInterestDeposit),
        midInterestDeposit: _dashedOutOrWithPrecision(lastMidInterestDeposit),
        highInterestDeposit: _dashedOutOrWithPrecision(lastHighInterestDeposit),
      },
      totalNonGuaranteeDividend: {
        totalInterestDeposit: _dashedOutOrWithPrecision(totalGuaranteeDividend),
        lowInterestDeposit: _dashedOutOrWithPrecision(d(totalGuaranteeDividend).plus(lastLowInterestDeposit)),
        midInterestDeposit: _dashedOutOrWithPrecision(d(totalGuaranteeDividend).plus(lastMidInterestDeposit)),
        highInterestDeposit: _dashedOutOrWithPrecision(d(totalGuaranteeDividend).plus(lastHighInterestDeposit)),
      },
    }
  }
)
